import { useState, useEffect } from "react";

import moment from "moment";

/**
 * @param {string} searchTerm term to be searched
 * @param {Array<string>=} columnsToSearch optional array of specific column names to be searched in
 * @param {Array} allData data to search from (may be pre filtered)
 */
const customTableSearch = (searchTerm, columnsToSearch, allData) => {
  searchTerm = searchTerm.toLowerCase();

  if (searchTerm.trim() === "") {
    return null;
  }

  let filteredData = [];
  for (const row of allData) {
    let contains = false;
    for (const col of columnsToSearch) {
      let property = row[col];
      //date to string convert
      if (property instanceof Date) {
        property = moment(property).format("MM-DD-YYYY");
      } else {
        property = (property + "").toLowerCase();
      }

      if (property.includes(searchTerm)) {
        contains = true;
        break;
      }
    }
    if (contains) {
      filteredData.push(row);
    }
  }
  return filteredData;
};

/**
 * @param { Array<string> searchableColumns, Array allData} props term to be searched
 *
 **/
const useTableSearch = function (props) {
  //recieve full data set with fields for searching
  const { searchableColumns, allData } = props;

  const [filteredTableData, setFilteredTableData] = useState(null);
  const [searchMeta, setSearchMeta] = useState({});
  const [searchedColumns, setSearchedColumns] = useState([]);
  const [searchedWords, setSearchedWords] = useState([]);

  /**
   * @param {String} searchTerm text to be searched
   * @param {String} searchInput origin/identifier of search
   * @param {Array<string>} columnsToSearch fields to apply search in
   */
  const updateSearchMeta = (searchTerm, searchInput, columnsToSearch) => {
    let tempMeta = { ...searchMeta };

    //search cleared -> empty meta
    if (searchTerm.trim() === "") {
      delete tempMeta[searchInput];
    } else {
      tempMeta[searchInput] = {
        searchTerm: searchTerm,
        columnsToSearch: columnsToSearch || searchableColumns,
      };
    }
    setSearchMeta(tempMeta);
  };

  //perform search when meta is updated
  useEffect(() => {
    const searchKeys = Object.keys(searchMeta);

    let tempFilteredTableData = null;
    let searchedWords = [];
    let searchedColumns = [];
    if (searchKeys.length > 0) {
      for (const key of searchKeys) {
        searchedColumns = searchedColumns.concat(
          searchMeta[key].columnsToSearch,
        );
        searchedWords = searchedWords.concat(searchMeta[key].searchTerm);

        //call custom search function
        tempFilteredTableData = customTableSearch(
          searchMeta[key].searchTerm,
          searchMeta[key].columnsToSearch,
          tempFilteredTableData || allData,
        );
      }
    }
    setSearchedWords([...new Set(searchedWords)]);
    setSearchedColumns([...new Set(searchedColumns)]);
    setFilteredTableData(tempFilteredTableData);
  }, [searchMeta]);

  //rerun search
  const refreshTableSearch = () => {
    setSearchMeta({ ...searchMeta });
  };

  return {
    filteredTableData: filteredTableData,
    searchMeta: searchMeta,
    searchedColumns: searchedColumns,
    searchedWords: searchedWords,
    setFilteredTableData: setFilteredTableData,
    setSearchMeta: setSearchMeta,
    setSearchedColumns: setSearchedColumns,
    setSearchedWords: setSearchedWords,
    updateSearchMeta: updateSearchMeta,
    refreshTableSearch: refreshTableSearch,
  };
};

export default useTableSearch;
